import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import DrivingTestService from '@services/driving-test'

// Server messages are written for staff: show them as returned.
export const errorText = (err) => {
  const message = err?.response?.data?.message
  const text = typeof message === 'object' && !Array.isArray(message) ? message?.message : message
  return Array.isArray(text) ? text.join(', ') : text || 'Something went wrong'
}

const thunk = (name, call) => createAsyncThunk(`learnerTheory/${name}`, async (arg, { rejectWithValue }) => {
    try {
      return await call(arg)
    } catch (err) {
      return rejectWithValue(errorText(err))
    }
  })

export const getSessions = thunk('getSessions', async (params) => {
  const res = await DrivingTestService.getLearnerTheorySessions(params)
  return { data: res.data, total: res.meta.itemCount }
})
export const addSession = thunk('addSession', (data) => DrivingTestService.addLearnerTheorySession(data))
export const cancelSession = thunk('cancelSession', (id) => DrivingTestService.cancelLearnerTheorySession(id))
export const getSession = thunk('getSession', (id) => DrivingTestService.getLearnerTheorySession(id))
export const getCandidates = thunk('getCandidates', (id) => DrivingTestService.getLearnerTheoryCandidates(id))
export const startSession = thunk('startSession', (id) => DrivingTestService.startLearnerTheorySession(id))
export const completeSession = thunk('completeSession', (id) => DrivingTestService.completeLearnerTheorySession(id))
export const resendCode = thunk('resendCode', (bookingId) => DrivingTestService.resendLearnerTheoryCode(bookingId))
export const markAbsent = thunk('markAbsent', (bookingId) => DrivingTestService.markLearnerTheoryAbsent(bookingId))
export const getResults = thunk('getResults', (params) => DrivingTestService.getLearnerTheoryResults(params))

const slice = createSlice({
  name: 'learnerTheory',
  initialState: { sessions: [], total: 0, session: null, candidates: [], results: null },
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getSessions.fulfilled, (state, { payload }) => {
        state.sessions = payload.data
        state.total = payload.total
      })
      .addCase(getSession.fulfilled, (state, { payload }) => {
        state.session = payload
      })
      .addCase(getCandidates.fulfilled, (state, { payload }) => {
        state.candidates = payload
      })
      .addCase(getResults.fulfilled, (state, { payload }) => {
        state.results = payload
      })
  }
})

export default slice.reducer
